import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Card from '../components/Card';
import QRCodeGenerator from '../components/QRCodeGenerator';
import { getCardById } from '../utils/cardStorage';
import { NotificationManager } from '../components/Notification';
import '../styles/Profile.css';

const Profile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    // Utilise getCardById directement
    const foundProfile = getCardById(id);
    
    if (foundProfile) {
      setProfile(foundProfile);
      setLoading(false);
    } else {
      NotificationManager.show('Erreur', 'Carte de visite introuvable', 'error');
      navigate('/404');
    }
  }, [id, navigate]);
  
  if (loading) {
    return (
      <div className="container">
        <div className="main-content loading-container">
          <p>Chargement...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="container">
      <div className="main-content">
        <div className="profile-header">
          <button onClick={() => navigate('/')} className="back-btn">
            &larr; Retour
          </button>
          <h1>Carte de Visite</h1>
          <button onClick={() => navigate(`/edit/${id}`)} className="edit-profile-btn">
            Modifier
          </button>
        </div>
        
        <Card profile={profile} />
        
        <div className="qr-section">
          <h2>Partagez cette carte</h2>
          <QRCodeGenerator profile={profile} />
        </div>
      </div>
    </div>
  );
};

export default Profile;
